import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import {CurveGeometryLine1} from "#template/nodes/geometry-graph/attribute/primitive/curve-geometry-line-1"
import {CurveGeometryLine2} from "#template/nodes/geometry-graph/attribute/primitive/curve-geometry-line-2"
import {CurveGeometryLine3} from "#template/nodes/geometry-graph/attribute/primitive/curve-geometry-line-3"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PrimitiveParameters} from "#template/nodes/geometry-graph/attribute/primitive/geometry-primitive-node"
import {GeometryPrimitiveNode} from "#template/nodes/geometry-graph/attribute/primitive/geometry-primitive-node"

export type CurveGeometryPrimitiveParameters = PrimitiveParameters<CurveGeometryLine1 | CurveGeometryLine2 | CurveGeometryLine3>

const definition: TemplateNodeDefinition<CurveGeometryPrimitiveParameters> = {
    nodeClass: "CurveGeometryPrimitive",
    validation: {
        parameters: z.object({
            name: z.string(),
            primitive: z.union([graphNode(CurveGeometryLine1), graphNode(CurveGeometryLine2), graphNode(CurveGeometryLine3)]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryPrimitive
    extends GeometryPrimitiveNode<1, CurveGeometryLine1 | CurveGeometryLine2 | CurveGeometryLine3>
    implements CurveGeometryAttributeLikeNode
{
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
